$(document).ready(function () {
    'use strict';

    $('.js_directionsForm').on('submit', function (e) {
        e.preventDefault();
    });

    $('.js_directionsForm #location_search').on('focus', function () {

        if (map_loaded !== true) {
            loadGoogleMapsOnDemand();
        }
    });
})